import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      detailsArr: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(diff_details) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var details, _i, _Object$entries, _Object$entries$_i, key, value, nodeName;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.detailsArr = [];
                details = diff_details || {};

                for (_i = 0, _Object$entries = Object.entries(details); _i < _Object$entries.length; _i++) {
                  _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];

                  if (key.includes('missing_in_') && value == true) {
                    nodeName = key.replace('missing_in_', '');

                    _this.detailsArr.push({
                      label: nodeName,
                      value: '缺失'
                    });
                  } else {
                    _this.detailsArr.push({
                      label: key,
                      value: JSON.stringify(value)
                    });
                  }
                }

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};